import { render, staticRenderFns } from "./addlist.vue?vue&type=template&id=de2ea622&scoped=true&"
import script from "./addlist.vue?vue&type=script&lang=js&"
export * from "./addlist.vue?vue&type=script&lang=js&"
import style0 from "./addlist.vue?vue&type=style&index=0&id=de2ea622&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2ea622",
  null
  
)

export default component.exports